import React from "react";
import { FileText, X } from "lucide-react";
import TailwindModal from "./TailwindModal";

export default function TaskDescriptionModal({ isOpen, onClose, description }) {
  return (
    <TailwindModal isOpen={isOpen} toggle={onClose} maxWidth="md">
      {/* Header */}
      <div className="flex min-w-0 items-center justify-between border-b border-slate-100 px-5 py-4">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-violet-100 bg-violet-50 text-violet-600">
            <FileText size={17} strokeWidth={2.2} />
          </div>

          <div className="min-w-0">
            <h2 className="m-0 text-[16px] font-semibold text-slate-900">
              Task Description
            </h2>

            <p className="m-0 mt-0.5 text-[11px] text-slate-500">
              View complete task details
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="flex h-8 w-8 shrink-0 
          items-center justify-center rounded-lg
           text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
        >
          <X size={17} />
        </button>
      </div>

      {/* Content */}
      <div
        className="
          min-h-0
          min-w-0
          w-full
          max-w-full
          max-h-[420px]
          overflow-y-auto
          overflow-x-hidden
          px-5
          py-4
        "
      >
        <div
          className="
            editor-content
            min-w-0
            w-full
            max-w-full
            overflow-hidden
            text-[14px]
            leading-[1.7]
            text-slate-700

            [&_p]:my-2
            [&_ul]:my-2
            [&_ul]:pl-5
            [&_ul]:space-y-1.5
            [&_ol]:my-2
            [&_ol]:pl-5
            [&_ol]:space-y-1.5
            [&_li]:min-w-0

            [&_img]:block
            [&_img]:h-auto
            [&_img]:max-w-full

            [&_pre]:max-w-full
            [&_pre]:overflow-x-auto
            [&_pre]:whitespace-pre-wrap

            [&_table]:block
            [&_table]:max-w-full
            [&_table]:overflow-x-auto
          "
          style={{
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "normal",
          }}
          dangerouslySetInnerHTML={{
            __html: description || "",
          }}
        />

        {/* Force wrapping for all HTML generated inside description */}
        <style>
          {`
            .editor-content,
            .editor-content * {
              max-width: 100% !important;
              min-width: 0 !important;
              box-sizing: border-box !important;
              overflow-wrap: break-word !important;
              word-break: normal !important;
              white-space: normal !important;
              background-color: transparent !important;
            }

            .editor-content a {
              display: inline !important;
              overflow-wrap: break-word !important;
              word-break: break-all !important;
              white-space: normal !important;
            }

            .editor-content p,
            .editor-content li,
            .editor-content div,
            .editor-content span {
              overflow-wrap: break-word !important;
              word-break: normal !important;
            }

            .editor-content pre,
            .editor-content code {
              white-space: pre-wrap !important;
              overflow-wrap: break-word !important;
              word-break: normal !important;
              max-width: 100% !important;
            }

            .editor-content img {
              max-width: 100% !important;
              height: auto !important;
            }
          `}
        </style>
      </div>
    </TailwindModal>
  );
}
